// extracted by mini-css-extract-plugin
export default {"container":"InfoCardTemplate_container__fvI4G","label":"InfoCardTemplate_label__whnmp","value":"InfoCardTemplate_value__yT7Gw"};